import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-new-round-preparation',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './new-round-preparation.component.html',
    styleUrl: './new-round-preparation.component.scss'
})
export class NewRoundPreparationComponent {}
